import { useEffect } from "react";

const APP_NAME = "Adge AI";

export function useDocumentTitle(suffix?: string) {
  useEffect(() => {
    document.title = suffix ? `${APP_NAME} / ${suffix}` : APP_NAME;
    return () => {
      document.title = APP_NAME;
    };
  }, [suffix]);
}
